import { compose, borders, color, flexbox, grid, layout, position, shadow, space, typography, opacity } from 'styled-system';

const systemPropsFns = compose(borders, color, flexbox, grid, layout, position, shadow, space, typography, opacity);
const allSystemProps = systemPropsFns.propNames;
const OMITTED_SYSTEM_PROPS = ["size"];
const systemProps = allSystemProps == null ? void 0 : allSystemProps.filter((prop) => !OMITTED_SYSTEM_PROPS.includes(prop));
const isSystemProp = (prop) => systemProps == null ? void 0 : systemProps.includes(prop);
const getSystemProps = (props) => Object.fromEntries(Object.entries(props).filter(([key]) => isSystemProp(key)));
const omitSystemProps = (props) => Object.fromEntries(Object.entries(props).filter(([key]) => !isSystemProp(key)));

export { allSystemProps, getSystemProps, omitSystemProps, systemProps, systemPropsFns };
//# sourceMappingURL=styled-system.es.js.map
